import { getValidClassNames } from "@/utils";
import { OnboardingCardProps } from "./OnboardingCard.interfaces";

export const OnboardingCard = ({ 
  children, 
  image = { 
    altText: 'Login',
    src: '/images/using-program-icon.svg'
  },
  isReversed
}: OnboardingCardProps) => {

  const { altText, src } = image;

  return(
    <div className={getValidClassNames({
      "flex flex-wrap border border-black rounded-lg overflow-hidden": true,
      "flex-row-reverse": Boolean(isReversed)
    })}>
      <div className="w-full md:w-1/2">
        <div className="bg-feijoa h-full flex justify-center items-center p-12 py-16">
          <img alt={altText} className="w-4/5" src={src} />
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <div className="bg-white h-full p-12 flex flex-col h-full justify-center">
          {children}
        </div>
      </div>
    </div>
  )
};